const INVISIBLE_CHARACTER = /[\p{C}\p{Z}]/u;

function describeCharacter(character: string): string {
  if (!INVISIBLE_CHARACTER.test(character)) return `"${character}"`;
  const hex = character
    .codePointAt(0)!
    .toString(16)
    .toUpperCase()
    .padStart(4, "0");
  return `U+${hex}`;
}

export function describeDisallowedCharacters(characters: string[]): string {
  return `Contains disallowed character(s) ${characters.map(describeCharacter).join(", ")}`;
}
